var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "my_table",
      style: { width: _vm.table_style["table_width"] }
    },
    [
      _c("div", { staticClass: "table-head" }, [
        _c(
          "div",
          {
            staticClass: "head_title",
            style: { width: _vm.table_style["head_title_width"] }
          },
          [_vm._v("\n             题头\n         ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "head_content" }, [
          _vm._v("\n            PB(i)\n         ")
        ])
      ]),
      _vm._v(" "),
      _c("dv-decoration-2", {
        staticClass: "line-v",
        style: { width: "5px", left: _vm.table_style["head_title_width"] },
        attrs: { reverse: true }
      }),
      _vm._v(" "),
      _c("dv-decoration-10", {
        staticClass: "line-h",
        staticStyle: { height: "5px" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "table-content" }, [
        _c(
          "div",
          {
            staticClass: "row-title",
            style: { width: _vm.table_style["head_title_width"] }
          },
          _vm._l(_vm.data, function(v, k, i) {
            return _c(
              "div",
              {
                key: i,
                style: {
                  height: _vm.table_style["grid_height"],
                  width: _vm.table_style["head_title_width"]
                }
              },
              [_vm._v("\n                " + _vm._s(k) + "\n             ")]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row-content" }, [
          _c(
            "table",
            {
              staticStyle: {
                width: "100%",
                height: "100%",
                "text-align": "center"
              }
            },
            _vm._l(_vm.data, function(v, i) {
              return _c(
                "tr",
                { key: i, style: { height: _vm.table_style["grid_height"] } },
                _vm._l(v, function(d, idx) {
                  return _c(
                    "td",
                    {
                      key: idx,
                      style: { width: _vm.table_style["grid_width"] }
                    },
                    [_vm._v(_vm._s(d))]
                  )
                }),
                0
              )
            }),
            0
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }